import { useQuery } from 'react-query';
import axios from 'axios';
import { AdminAnalyticsAndReportsAPI } from '../../../../constants/API';
import { commonHeaders } from '../../../../constants/HeadersAPI';

type CurrentServicesQueueType = {
  topicName: string;
  clientInQueue: string;
  avgTime: string;
};

export const useGetCurrentServicesQueue = (branchQueueId?: number | null) => {
  const {
    data: currentServicesQueueResp,
    isLoading: isLoadingCurrentServicesQueue,
    isSuccess: isCurrentServicesQueueRecieved
  } = useQuery(
    ['currentServicesQueue', branchQueueId ?? null],
    () =>
      axios.get<CurrentServicesQueueType[]>(
        `${AdminAnalyticsAndReportsAPI.getCurrentServicesStatusQueue}${
          branchQueueId ? `?branchQueueId=${branchQueueId}` : ''
        }`,
        commonHeaders()
      ),
    {
      enabled: branchQueueId != null,
      keepPreviousData: true,
      refetchInterval: 60_000,
      refetchIntervalInBackground: true,
      select: ({ data }) => {
        if (data?.length) {
          return data
            .filter((e) => {
              const raw = String(e.clientInQueue ?? '').trim();
              const parsed = Number(raw.replace(/[^\d.-]/g, ''));
              return Number.isFinite(parsed) ? parsed !== 0 : true;
            })
            .map((e) => {
              return {
                serviceName: e.topicName,
                queue: e.clientInQueue,
                queuingTime: e.avgTime
              };
            });
        } else {
          return [];
        }
      }
    }
  );

  return {
    currentServicesQueueResp,
    isLoadingCurrentServicesQueue,
    isCurrentServicesQueueRecieved
  };
};
